import React, { Fragment } from "react";
import BannerSection from "./bannerSection";
import PartnerSection from "./partnerSection";
import WhyChooseUs from "./whyChooseUs";
import ProductsSection from "./products";
import FAQSection from "./faqSection";
import TestimonailSection from "./testimonialSection";
import CounterSection from "./countersection";
import WhatVaidyoHas from "./whatVaidyoHas";
import AboutSection from "./aboutSection";
import HowWeWork from "./howWeWork";
import RequirementSection from "./requirementSection";
function Home() {
  window.scrollTo(0 , 0);
  return (
    <Fragment>
      <BannerSection />
      <CounterSection />
      <PartnerSection />
      <AboutSection/>
      <WhyChooseUs />
      {/* <HowWeWork/> */}
      <ProductsSection />
      <FAQSection />
      {/* <WhatVaidyoHas/> */}
      <TestimonailSection />
      <RequirementSection/>
    </Fragment>
  );
}

export default Home;
